import React, { useEffect } from 'react';


const AndroidPage = () => {
    useEffect(() => {
        window.location.replace("https://play.google.com/store/apps/details?id=com.mosaicclub");
    }, []);

    return (
        <>
        </>
    );
}

export default AndroidPage;